import axios from 'axios'
import LetsDialAPI, { LetsDialAPIType } from '@letsdial/api/src'
import { letsDialAPI } from './plugin'

export default function useLetsDialAPI(baseUrl = '/api'): LetsDialAPIType {
  return letsDialAPI ?? LetsDialAPI(axios, baseUrl)
}
